import React from "react";
import { useLang } from "@/i18n";
import { CONTACT, waLink, mailLink } from "@/data/site";
import { FlaskConical, Instagram, MessageCircle, MapPin, Phone, Mail } from "lucide-react";

const quick = [
  ["Home", "#top"], ["About", "#about"], ["Services", "#services"],
  ["Wellness Packages", "#wellness"], ["Hospitals", "#hospitals"], ["Careers", "#careers"], ["Contact", "#contact"],
];

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-navy text-white pt-16 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 md:px-10 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2.5">
            <div className="w-10 h-10 rounded-2xl bg-white/10 flex items-center justify-center"><FlaskConical className="w-5 h-5 text-turq-light" /></div>
            <div className="leading-tight"><span className="block font-heading font-bold text-lg">DOABA</span><span className="block text-[10px] tracking-[0.2em] uppercase text-turq-light">Diagnostics</span></div>
          </div>
          <p className="text-white/60 text-sm mt-4 leading-relaxed">Accurate tests, trusted care. Fast, accurate & affordable blood testing with home sample collection and same-day digital reports.</p>
          <div className="flex gap-3 mt-5">
            <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors" data-testid="footer-instagram"><Instagram className="w-5 h-5" /></a>
            <a href={waLink()} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-emerald-500 hover:bg-emerald-600 flex items-center justify-center transition-colors" data-testid="footer-whatsapp"><MessageCircle className="w-5 h-5" /></a>
            <a href={CONTACT.mapsLink} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors" data-testid="footer-maps"><MapPin className="w-5 h-5" /></a>
          </div>
        </div>

        <div>
          <h4 className="font-heading font-semibold mb-4">{t("footer_quick")}</h4>
          <ul className="space-y-2.5">
            {quick.map(([label, h]) => <li key={label}><a href={h} className="text-white/60 hover:text-turq-light text-sm transition-colors" data-testid={`footer-link-${label}`}>{label}</a></li>)}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold mb-4">{t("footer_hours")}</h4>
          {CONTACT.hours.map((h) => (
            <div key={h.day} className="mb-2"><p className="text-white text-sm">{h.day}</p><p className="text-turq-light text-sm">{h.time}</p></div>
          ))}
        </div>

        <div>
          <h4 className="font-heading font-semibold mb-4">{t("footer_contact")}</h4>
          <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-2 text-white/70 hover:text-turq-light text-sm mb-3"><Phone className="w-4 h-4 shrink-0" /> {CONTACT.phoneDisplay}</a>
          <a href={mailLink} className="flex items-center gap-2 text-white/70 hover:text-turq-light text-sm mb-3 break-all" data-testid="footer-email"><Mail className="w-4 h-4 shrink-0" /> {CONTACT.email}</a>
          <a href={waLink()} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-white/70 hover:text-turq-light text-sm mb-3"><MessageCircle className="w-4 h-4 shrink-0" /> WhatsApp Chat</a>
          <a href={CONTACT.mapsLink} target="_blank" rel="noreferrer" className="flex items-start gap-2 text-white/70 hover:text-turq-light text-sm mb-3"><MapPin className="w-4 h-4 mt-0.5 shrink-0" /> {CONTACT.addressLines.join(", ")}</a>
          <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-white/70 hover:text-turq-light text-sm"><Instagram className="w-4 h-4 shrink-0" /> {CONTACT.instagramHandle}</a>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-5 md:px-10 mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-3">
        <p className="text-white/50 text-sm">© {new Date().getFullYear()} DOABA Diagnostics Laboratory. All rights reserved.</p>
        <a href="/admin" className="text-white/40 hover:text-turq-light text-xs transition-colors" data-testid="footer-admin-link">Staff Login</a>
      </div>
    </footer>
  );
}
